import React, { useMemo } from 'react';

import ToggleSwitch from 'components/shared/ToggleSwitch/ToggleSwitch';

import { getMedicationToggleItems } from '../../lib/medicationTableViews';

const MedicationTableViewSwitch = ({
  activeView = null,
  onChange = () => {},
  allLabel = 'All Medications',
  includePrescribedByMe = true,
  className = '',
  variant,
  sizedByContainer
}) => {
  const items = useMemo(() => {
    return getMedicationToggleItems({
      allLabel,
      includePrescribedByMe
    });
  }, [allLabel, includePrescribedByMe]);

  return (
    <ToggleSwitch
      items={items}
      active={activeView}
      onClick={(item) => onChange(item?.value ?? null)}
      className={className}
      variant={variant}
      sizedByContainer={sizedByContainer}
    />
  );
};

export default MedicationTableViewSwitch;
